// import { LifeUserPolicies } from 'all-in-one-shared-api';
import { useEffect, useState } from 'react';
import { useKeycloakReady } from 'hooks';
import { useTranslation } from 'react-i18next';
import { isLocaleEnglish } from 'utils/languageUtils';
import { Row, Col, Tooltip, Divider, Grid, Typography } from 'antd';
import './PoliciesValues.less';
const { useBreakpoint } = Grid;
import styled from 'styled-components';
import { useLifePolicyValue } from 'all-in-one-shared-api';
import { changeDataFun } from 'utils/formate';
const { Text } = Typography;
// import { SvgXml } from 'react-native-svg';
import TooltipIcon from 'assets/images/policy/Tooltip.svg';
import { setPvaluesCode } from 'utils/policyValues';
interface PvLocationState {
  policyNo?: string;
  companyCode?: string;
  planCode?: string;
}
type PolicyDetailProps = {
  pValues: PvLocationState;
};
interface PdRowProps {
  paddingFlag?: string;
  padB?: string;
}
interface PolicyValue {
  valueType: string;
  valueDesc: string;
  valueDescTc: string;
  valueAmount: string;
  valueTypeUrl: string;
  currencyCode: string;
  currencyCodeDesc: string;
  currencyCodeDescTc: string;
  orderNo?: number;
}
const StyledBlock = styled.div`
  width: 100%;
  // background: #fff;
  margin-bottom: 1rem;
`;
const Androw = styled(Row)<PdRowProps>`
  max-width: 640px;
  margin: 0 auto;
  padding-top: ${(props) => (props.paddingFlag ? props.paddingFlag : `0`)};
  padding-bottom: ${(props) => (props.padB ? props.padB : `0`)};
`;
const AndCol = styled(Col)`
  margin: 0 16px;
`;
const PolicyDetail = ({ pValues }: PolicyDetailProps) => {
  const { t, i18n } = useTranslation();
  const isEnglish = isLocaleEnglish(i18n.language);
  const { token } = useKeycloakReady();
  const { lg, xs, md } = useBreakpoint();
  const [valueList, setValueList] = useState<PolicyValue[]>([]);
  const [loanList, setLoanList] = useState<PolicyValue[]>([]);

  const { shouldFetch, data } = useLifePolicyValue(
    'useLifePolicyValue',
    token ?? '',
    pValues.policyNo ?? '',
    pValues.companyCode ?? '',
  );

  useEffect(() => {
    if (!pValues) return;
    shouldFetch(true);
  }, [shouldFetch, pValues]);
  useEffect(() => {
    if (!data) return;
    setValueList(data.policyValues.filter((item) => item.valueDesc != 'Policy Loan'));
    setLoanList(data.policyValues.filter((item) => item.valueDesc == 'Policy Loan'));
  }, [data]);
  const handleTootip = (valueDesc: string) => {
    return setPvaluesCode(valueDesc, isEnglish, pValues.planCode);
    // if (valueDesc == 'Terminal Dividend') {
    //   return isEnglish
    //     ? 'The amount is not guaranteed. It is determined by Generali at its absolute discretion. It may be payable upon surrender (whether in full or part), policy termination or any other conditions specified by the Policy Provisions of relevant products. For details, please refer to the relevant policy provisions.'
    //     : '終期紅利並非保證，並由本公司擁有絕對決定權下不時訂定。終期紅利或於保單退保（不論完全或部分退保），保單終止或因有關產品的保單條款列明的其他情況發生時而支付。欲知詳情，請參閱有關保單條款。';
    // } else {
    //   return isEnglish
    //     ? 'The amount is not guaranteed. It is determined by Generali at its absolute discretion. It may be payable upon surrender (whether in full or part), policy termination or any other conditions specified by the Policy Provisions of relevant products. For details, please refer to the relevant policy provisions.'
    //     : '特別紅利並非保證，並由本公司擁有絕對決定權下不時訂定。特別紅利或於保單退保（不論完全或部分退保），保單終止或因有關產品的保單條款列明的其他情況發生時而支付。欲知詳情，請參閱有關保單條款。';
    // }
  };
  return (
    <div className="policy-detail-wrap">
      <StyledBlock className="base-detail">
        <Androw justify="start" paddingFlag={lg ? '40px' : '16px'}>
          <AndCol className="font-setting500 font-size17 grey-font ">
            {t('life.policies.policyValueDesc', {
              date: isEnglish ? data?.policyValueDate : changeDataFun(data?.policyValueDate),
            })}
          </AndCol>
        </Androw>
        {xs && <Divider style={{ margin: '16px 0' }}></Divider>}
        {data?.policyValues && data?.policyValues.length > 0 ? (
          <>
            <div>
              <div className="value-content">
                <Androw justify="start" align="middle" style={{ marginTop: '15px' }}>
                  <AndCol className={`${lg ? 'font-size20' : 'font-size17'}`}>{t('life.policies.type1')}</AndCol>
                </Androw>
              </div>
              {valueList.length > 0 && (
                <div className="value-content">
                  <div className="background" style={{ paddingBottom: '15px' }}>
                    {valueList.map((value, index) => {
                      return (
                        <Androw justify="start" align="middle" key={index} style={{ paddingTop: '15px' }}>
                          <AndCol>
                            <img src={value.valueTypeUrl} alt="" />
                          </AndCol>
                          <Col style={{ width: 'calc(100% - 40px)' }}>
                            <Androw justify="space-between" align="top">
                              <Col span={20}>
                                <p
                                  className="p-bottom font-setting500 font-size15 letter-space4 grey-font"
                                  style={{ marginBottom: '8px' }}
                                >
                                  {isEnglish ? value.valueDesc : value.valueDescTc}
                                </p>
                              </Col>

                              {setPvaluesCode(value.valueDesc, isEnglish, pValues.planCode) && (
                                <AndCol span={1}>
                                  <Tooltip
                                    trigger="click"
                                    title={() => handleTootip(value.valueDesc)}
                                    arrowPointAtCenter
                                    overlayInnerStyle={{ whiteSpace: 'pre-line' }}
                                    autoAdjustOverflow
                                    placement="bottomRight"
                                    overlayStyle={{ maxWidth: md ? '400px' : '300px' }}
                                  >
                                    <img
                                      src={TooltipIcon}
                                      alt=""
                                      style={{ cursor: 'pointer' }}
                                      width={20}
                                      height={20}
                                    />
                                  </Tooltip>
                                </AndCol>
                              )}
                            </Androw>
                            <p className="p-bottom font-size22 letter-space4 ">
                              {(isEnglish ? value.currencyCodeDesc : value.currencyCodeDescTc) + value.valueAmount}
                            </p>
                          </Col>
                        </Androw>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
            {loanList.length > 0 && (
              <div>
                <div className="value-content">
                  <Androw justify="start" align="middle" style={{ marginTop: '15px' }}>
                    <AndCol className={`${lg ? 'font-size20' : 'font-size17'}`}>{t('life.policies.type2')}</AndCol>
                  </Androw>
                </div>

                <div className="value-content">
                  <div className="background" style={{ paddingBottom: '15px' }}>
                    {loanList.map((value, index) => {
                      return (
                        <Androw justify="start" align="middle" key={index} style={{ paddingTop: '15px' }}>
                          <AndCol>
                            <img src={value.valueTypeUrl} alt="" />
                          </AndCol>
                          <Col style={{ width: 'calc(100% - 40px)' }}>
                            <Androw justify="space-between" align="top">
                              <Col span={20}>
                                <p
                                  className="p-bottom font-setting500 font-size15 letter-space4 grey-font"
                                  style={{ marginBottom: '8px' }}
                                >
                                  {isEnglish ? value.valueDesc : value.valueDescTc}
                                </p>
                              </Col>
                              <AndCol span={1}>
                                <Tooltip
                                  trigger="click"
                                  title={() => handleTootip(value.valueDesc)}
                                  arrowPointAtCenter
                                  overlayInnerStyle={{ whiteSpace: 'pre-line' }}
                                  autoAdjustOverflow
                                  overlayStyle={{ maxWidth: md ? '400px' : '300px' }}
                                  placement="bottomRight"
                                >
                                  <img src={TooltipIcon} alt="" style={{ cursor: 'pointer' }} width={20} height={20} />
                                </Tooltip>
                              </AndCol>
                            </Androw>
                            <p className="p-bottom font-size22 letter-space4 ">
                              {(isEnglish ? value.currencyCodeDesc : value.currencyCodeDescTc) + value.valueAmount}
                            </p>
                          </Col>
                        </Androw>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
          </>
        ) : (
          <Androw justify="start" paddingFlag={lg ? '40px' : '16px'}>
            <AndCol className="font-size17 grey-font ">
              <Text style={{ margin: '16px' }} className="grey-font">
                {isEnglish ? 'No value available.' : '沒有任何記錄'}
              </Text>
            </AndCol>
          </Androw>
        )}
      </StyledBlock>
    </div>
  );
};
export default PolicyDetail;
